import { locationPageCrumbs } from "../structured-data-core";
import { serviceAreaSchema } from "./service-area";

export function getEdinaStructuredData() {
  const url = "https://restorehair.com/locations/minnesota/edina/";
  const description =
    "Find out about your hair transplant options in Edina with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    serviceAreaSchema("edina", url, description),
    locationPageCrumbs(url, "Edina"),
  ];
}
